import { computed } from 'vue'
import { useQuoteStore, useUserStore } from '@/shared/store'
import { PLANS_WITH_ADDONS_ID } from '@/shared/constants/flow.constants'
import { WINTER_SPORTS_ADDON_ID } from '@/shared/constants/addons.constants'

export const useWinterSport = () => {
  const userStore = useUserStore()
  const quoteStore = useQuoteStore()
  const withWinterSport = computed(() =>
    PLANS_WITH_ADDONS_ID.includes(Number(userStore.selectedPlan))
  )

  const fetchWinterSportPrice = async (): Promise<number> => {
    if (!userStore.selectedPlan) {
      return 0
    }

    const destinationIds = userStore.destination.map((country) => country.id)
    const plan = await quoteStore.getTravelQuoteByScheme(
      userStore.selectedPlan,
      userStore.promocode ?? '',
      0,
      destinationIds
    )

    if (!plan) {
      return 0
    }

    return plan.ids.find((addon) => addon.id === WINTER_SPORTS_ADDON_ID)?.value || 0
  }

  return {
    withWinterSport,
    fetchWinterSportPrice,
  }
}
